module.exports = __webpack_public_path__ + "static/media/tesla-t-red.434cf521.png";